import _ from 'lodash';
import vapi from '../../../javascript/frontend/api/vapi';
import vlog from '../../../javascript/vlog';

const MIN_AUTOSAVE_CHARS = 10;
const lastSavedByPitchId = new Map();

async function saveToBackend(pitchId, pitchText, sourceRequestId) {
  try {
    vlog.info('autosave#saveToBackend', { pitchId, textLength: pitchText.length, sourceRequestId });

    const attrs = {
      pitch: pitchText,
      content_format: 'html',
      draft: true,
      source_request_id: sourceRequestId,
    };

    const response = await vapi.autosavePitch(pitchId, attrs);

    vlog.info('autosave#saveToBackend success', { pitchId });
    return response;
  } catch (error) {
    vlog.error('autosave#saveToBackend error', { pitchId, error: error.message });
    throw error;
  }
}

// Autosave with 30s debounce to reduce Kafka feed noise from draft pitch updates
// - Saves 30s after user stops typing
// - Force-saves every 60s if continuously typing
// - Reduces draft saves by ~6-12x compared to previous 5s debounce
const debouncedSave = _.debounce(async (pitchId, pitchText, sourceRequestId, onSuccess, onError) => {
  try {
    const response = await saveToBackend(pitchId, pitchText, sourceRequestId);
    if (response && (response.data?.success || response.data?.autosaved)) {
      lastSavedByPitchId.set(pitchId, pitchText);
      if (onSuccess) onSuccess();
    } else if (onError) onError();
  } catch (err) {
    if (onError) onError(err);
  }
}, 30000, {
  leading: false,
  trailing: true,
  maxWait: 60000,
});

export function autoSavePitchText(pitchId, pitchText, sourceRequestId, onSuccess, onError) {
  const text = (pitchText || '').trim();

  if (text.length <= MIN_AUTOSAVE_CHARS) {
    vlog.info('autosave#skipped', { pitchId, textLength: text.length, reason: 'Below minimum character count' });
    return;
  }

  const lastSaved = (lastSavedByPitchId.get(pitchId) || '').trim();
  if (text === lastSaved) {
    vlog.info('autosave#skipped', { pitchId, textLength: text.length, reason: 'No changes since last save' });
    return;
  }

  debouncedSave(pitchId, text, sourceRequestId, onSuccess, onError);
}

export function cancelAutosave() {
  debouncedSave.cancel();
}

export default autoSavePitchText;
